/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBloodPressure = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M12 1s6.636 5.808 7.82 11.652H22v2h-2.008C19.832 18.736 16.317 22 12 22s-7.833-3.264-7.992-7.348H2v-2h2.18C5.365 6.808 12 1 12 1zM9.166 14.058a1 1 0 0 1-.914.594H6.009C6.168 17.554 8.706 20 12 20c3.294 0 5.832-2.446 5.991-5.348h-2.17a1 1 0 0 1-.895-.554l-.187-.375-1.049 3.56a1 1 0 0 1-1.884.095L9.835 12.55zM12 3.776a34.208 34.208 0 0 0-2.428 2.755c-1.52 1.936-2.828 4.1-3.34 6.121h1.37L8.96 9.594l.07-.131a1 1 0 0 1 1.77.16l1.78 4.358.961-3.263.054-.143a1 1 0 0 1 1.8-.021l1.045 2.098h1.328c-.512-2.02-1.82-4.185-3.34-6.12A34.203 34.203 0 0 0 12 3.775z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgBloodPressure as BloodPressure };
